import { useEffect } from 'react';
import { trackEvent } from 'sonora-services/analytics';

export const useTrackEventOnMount = (event: string, data?: any) => {
  return useEffect(() => {
    trackEvent(event, data);
  }, []);
};
